module.exports = __webpack_public_path__ + "img/7.5d708d5e.png";